import { render } from "./SidebarMain.vue?vue&type=template&id=399df11e&scoped=true&lang=pug"
import script from "./SidebarMain.vue?vue&type=script&lang=js"
export * from "./SidebarMain.vue?vue&type=script&lang=js"

import "./SidebarMain.vue?vue&type=style&index=0&id=399df11e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399df11e"]])

export default __exports__